export default "__VITE_ASSET__732b40b8__"